<template>
    <div>
        <b-row>
            <b-col>
                <b-form @submit.prevent="save">
                    <b-card>

                        <b-form-row>

                            <b-col lg="3" sm="12" class="text-left">
                                <lg-finder-status id="finderStatus" @onSelect="(item) => (form.status = item)"
                                    ref="finderStatus" title="Status - LISTAR">
                                </lg-finder-status>

                                <lg-form-input-finder v-model="form.status" fieldDescription="descricao" label="Status:"
                                    invalidFeedback=" " description="">
                                    <template #prepend>
                                        <b-button @click="$refs.finderStatus.show" class="btn-input-finder" pressed>
                                            <b-icon icon="search" />
                                        </b-button>
                                    </template>
                                </lg-form-input-finder>
                            </b-col>


                            <b-col lg="2" sm="12" class="text-left">
                                <lg-form-const-select label="Situação:" v-model="form.situacao"
                                    :options="form.optionsFilterSituacao" />
                            </b-col>


                            <b-col lg="3" sm="12" class="text-left">
                                <lg-form-input invalidFeedback="Informe a descrição" description=""
                                    v-model="form.descricao" label="Descrição:" maxlength="200" />
                            </b-col>

                            <b-col cols="3" class="text-right">
                                <b-button class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="clearForm">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="eraser" /> &nbsp;Limpar
                                    </div>
                                </b-button>
                                <b-button class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="load">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="search" /> &nbsp;Buscar
                                    </div>
                                </b-button>
                            </b-col>


                            <b-col cols="1">
                                <b-button class=" mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                                    @click="cadastrar">
                                    <div class="btn-size-alinhamento">
                                        <b-icon icon="plus" /> &nbsp;
                                    </div>
                                </b-button>
                            </b-col>


                        </b-form-row>

                        <b-form-row class="col-12">
                            <b-table class="col-12" responsive="sm" stacked="sm" small outlined sticky-header show-empty
                                head-variant="light" :busy="this.busy" :items="this.records" :fields="itensFields">

                                <template #table-busy>
                                    <div class="text-center text-primary my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </template>


                                <template #empty>
                                    <h6 style="text-align: center">
                                        Nenhum item vinculado
                                    </h6>
                                </template>

                                <template v-slot:cell(nomeArquivo)="{ item }">
                                    <span @click="baixarArquivo(item)"
                                        style="color:blue;cursor: pointer; text-decoration: underline;">{{
                                        item.cod+'_'+item.nomeArquivo }}</span>

                                </template>


                                <template v-slot:cell(edit)="{ item }">
                                    <b-icon class="hand-pointer" @click="editar(item)" icon="pencil" font-scale="2" />

                                </template>

                                <template v-slot:cell(desativar)="{ item }">
                                    <b-icon class="hand-pointer" @click="atualizarSituacao(0, item.cod)"
                                        v-if="item.situacao == 1" icon="square-fill" font-scale="2"
                                        style="color: green;"></b-icon>
                                    <b-icon class="hand-pointer" @click="atualizarSituacao(1, item.cod)"
                                        v-if="item.situacao == 0" icon="square" font-scale="2"
                                        style="color: green;"></b-icon>
                                </template>


                                <template #head()="data">
                                    <h6>{{ data.label.toUpperCase() }}</h6>
                                </template>
                            </b-table>
                            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página
                                        {{ page }} de {{
                                            totalPage }} -
                                        {{ total }} registros</b-col>
                                    <b-col cols="6"
                                        style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                            :options="perPageOptions">
                                        </b-form-select>
                                    </b-col>
                                </b-col>
                                <b-col cols="6">
                                    <div class="d-flex justify-content-end align-items-end">
                                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                            :per-page="perPage" :total-rows="total"></b-pagination>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-form-row>
                    </b-card>
                </b-form>
            </b-col>
        </b-row>
        <ModalDocumentoIBPAdicionar :idDocumento="idDocumento" :id="id" v-if="mostrarModal" @fecharModal="fecharModal"
            :edicao="edicao">
        </ModalDocumentoIBPAdicionar>
    </div>
</template>
<script>

import ModalDocumentoIBPAdicionar from "@/core/components/Modals/ModalDocumentoIBPAdicionar.vue"
import ResourceService from "@/core/api/ResourceService";
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFormCheckbox from "@/core/components/Form/LgFormCheckbox.vue";
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFinderPessoa from "@/components/Finders/LgFinderPessoa.vue";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFinderStatus from "@/components/Finders/LgFinderStatus.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import { FormResourceMixin, ListResourceMixin } from "@/core/mixins/resource";
import LgFormInputNumber from '@/core/components/Form/LgFormInputNumber.vue';
import DocumentoIBPService from "@/core/api/DocumentoIBPService";

export default {
    components: {
        LgFormSelect,
        LgFormInput,
        LgFormConstSelect,
        LgFinderStatus,
        LgFormCheckbox,
        LgFormDate,
        LgFormInputNumber,
        LgFinderPessoa,
        LgFormInputFinder,
        ModalDocumentoIBPAdicionar,

    },
    mixins: [FormResourceMixin, ListResourceMixin],
    props: {
        id: Number,
    },
    data() {
        return {
            mostrarModal: false,
            idDocumento: null,
            params: {},
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            edicao: false,
            form: {
                situacao: "1",
                descricao: '',
                status: '',
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

            },
            itensFields: [
                {
                    key: 'nomeArquivo', label: 'Arquivo do Documento',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'tipoDocumento.descricao', label: 'Tipo do Documento',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },
                {
                    key: 'status.descricao', label: 'Status',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },

                {
                    key: 'localArmazenamento.descricao', label: 'Localização Física',
                    thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",

                },

                {
                    key: 'edit', label: '', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'desativar', label: '', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: 'remover', label: '', thStyle: "font-size: 14px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },

            ],
        };
    },
    watch: {
        page() {
            this.load();
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/documento-ibp`);
        this.$documentoIBPService = new DocumentoIBPService();
        this.form.id = this.id;
    },


    async mounted() {
        this.load()
    },

    methods: {
        baixarArquivo(item) {
            var binaryString = window.atob(item.arquivoBase64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            var blob = new Blob([bytes], { type: "application/rtf" });

            var link = document.createElement('a');
            document.body.appendChild(link);

            link.href = window.webkitURL.createObjectURL(blob);
            link.download = item.nomeArquivo;
            link.click();
            document.body.removeChild(link);
        },
        showModal() {
            this.mostrarModal = true;
        },
        fecharModal() {
            this.mostrarModal = false;
            this.load();
        },
        cadastrar() {
            this.edicao = false;
            this.showModal();

        },
        editar(item) {
            this.idDocumento = item.cod;
            this.edicao = true;
            this.showModal();

        },
        atualizarSituacao(situacao, id) {


            this.busy = true;
            this.$documentoIBPService.atualizarSituacao(situacao, id).then(response => {

                this.busy = false;
                this.load();
                this.$notify({
                    type: "success",
                    message: response.data,
                });
            })
        },
        deletar(id) {


            this.busy = true;
            this.$documentoIBPService.deletar(id).then(response => {

                this.busy = false;
                this.load();
                this.$notify({
                    type: "success",
                    message: response.data,
                });
            })
        },
        atualizarPrincipal(principal, id) {


            this.busy = true;
            this.$documentoIBPService.atualizarPrincipal(principal, id).then(response => {

                this.busy = false;
                this.load();
                this.$notify({
                    type: "success",
                    message: response.data,
                });
            })
        },
        async load() {

            this.params.descricao = null;
            this.params.situacao = null;
            this.params.id = null;
            this.params.status = null;


            if (
                this.form.id &&
                this.form.id != ""
            ) {

                this.params.id = this.form.id;
            }


            if (this.form.status && this.form.status.id) {

                this.params.status = this.form.status.id;
            }

            if (this.form.descricao) {
                this.params.descricao = this.form.descricao;
            }

            if (this.form.situacao) {
                this.params.situacao = this.form.situacao;
            }



            this.busy = true;
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.params,
            });

        },
        clearForm() {

            this.form = {
                id: this.id,
                status: '',
                descricao: '',
                situacao: "1",
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: undefined },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

            };


        },

    },
};
</script>
<style>
.hand-pointer {
    cursor: pointer;
}
</style>